<script>
export default {
  name: "ConferenceRoom",
  props: {
    statusBuild: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      filter: {
        title: "",
        limit: null,
        current_page: null,
        roles: null,
      },

      items: {
        conference_rooms: [],
      },
    }
  },
  computed: {
    getConferenceRooms() {
      return this.items.conference_rooms
    },
    isConferenceRoomStarted() {
      return !!this.items.conference_rooms.find((item) => item.status === "activated")
    },
    isCompanyBuild() {
      return this.statusBuild === 1
    },
  },
  methods: {
    makeToast(body = "Ничего не произошло", variant = "success", title = "Уведомление") {
      this.$bvToast.toast(body, {
        title: title,
        autoHideDelay: 9000,
        appendToast: false,
        variant: variant,
        toaster: "b-toaster-bottom-center",
      })
    },
    fetchConferences() {
      axios
        .get("/webapi/conference/room", {
          params: this.filter,
        })
        .then(({data}) => {
          this.items.conference_rooms = data.data
        })
    },

    conferenceRoomDeactivate(uuid) {
      this.boxTwo = ""
      this.$bvModal
        .msgBoxConfirm("Действительно деактивировать конференцию?", {
          title: "Подтверждение деактивации мероприятия",
          size: "md",
          buttonSize: "md",
          okVariant: "danger",
          okTitle: "Деактивировать",
          cancelTitle: "Отменить",
          hideHeaderClose: true,
          centered: true,
          bodyClass: "h5",
          titleClass: "font-weight-bold",
          headerClass: "border-bottom-0",
          footerClass: "border-top-0",
        })
        .then((value) => {
          this.boxTwo = value
          if (this.boxTwo) {
            axios.patch(`/webapi/conference/room/${uuid}/deactivate`, {}).then(() => {
              this.makeToast("Конференция деактивирована")
              this.fetchConferences()
            })
          }
        })
        .catch((err) => {
          // An error occurred
        })
    },

    conferenceRoomActivate(uuid) {
      this.boxTwo = ""
      this.$bvModal
        .msgBoxConfirm("Действительно активировать конференцию?", {
          title: "Подтверждение активации мероприятия",
          size: "md",
          buttonSize: "md",
          okVariant: "success",
          okTitle: "Активировать",
          cancelTitle: "Отменить",
          hideHeaderClose: true,
          centered: true,
          bodyClass: "h5",
          titleClass: "font-weight-bold",
          headerClass: "border-bottom-0",
          footerClass: "border-top-0",
        })
        .then((value) => {
          this.boxTwo = value
          if (this.boxTwo) {
            axios.patch(`/webapi/conference/room/${uuid}/activate`, {}).then(() => {
              this.makeToast("Конференция активирована")
              this.fetchConferences()
            })
          }
        })
        .catch((err) => {
          // An error occurred
        })
    },
  },
  created() {
    this.fetchConferences()
  },
}
</script>

<style>
.conference-room {
  width: 40%;
  height: 40%;
}
</style>
